import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Iconify from '../iconify';
import Stack from '@mui/material/Stack';
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import 'dayjs/locale/it';
import { Stepper, Step, StepLabel, Chip, CircularProgress, FormControlLabel } from '@mui/material';
import ScSeatBooking from '../scSeatBooking/application'
import moment from 'moment'
import { useFormik } from 'formik';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export default function BookPopup({state, successCallback}) {
  const [activeStep, setActiveStep] = React.useState(4);
  const [selectedSeats, setSelectedSeats] = React.useState([]);
  const [privacy, setPrivacy] = React.useState([]);

  const initData = {
    email: undefined,
    name: undefined,
    surname: undefined,
    phone: undefined
  }

  const [notAvailableSeats, setNotAvailableSeats] = React.useState(initData);
  const [bookingSubmitted, setBookingSubmitted] = React.useState(false);

  useEffect(() => {
    if(state?.data?.open && state?.data?.loading)
    {
      //INIT POPUP
      setActiveStep(0);
      setPrivacy(false);
      setSelectedSeats([]);
      formik.resetForm({
        values: {
         email: undefined,
         phone: undefined,
         name: undefined,
         surname: undefined
        }});
      setBookingSubmitted(false);
      if(state?.data?.slot !== undefined)
      {
        SteLib.GetRequest("timetables/"+state?.data?.slot?.id, {}, true).then((data) => {
          setNotAvailableSeats(data.seatsBooked)
          //END LOADING
          state.setData({...state.data,  loading: false});
        }).catch((message) => {
          setActiveStep(-1);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.data?.open]);

  const handleClose = () => {
    state.setData(POPUP_INITDATA);
  };

  let handleSeatClick = (arg) => {
    setSelectedSeats(arg);
  }

  const handleSubmitForm = () => {
    if(fieldOk("email") &&
       fieldOk("name") &&
       fieldOk("surname") &&
       fieldOk("phone") &&
       privacy)
    {
      setActiveStep(2);
    }
  }

  const handleSubmitBooking = () => {
    let parsedFormData = {};
    parsedFormData.timetableId = state?.data?.slot?.id;
    parsedFormData.bookedBy = formik.values.email;
    parsedFormData.phone = formik.values.phone;
    parsedFormData.name = formik.values.name;
    parsedFormData.surname = formik.values.surname;
    parsedFormData.type = 1;
    parsedFormData.seats = selectedSeats;
    if(parsedFormData.timetableId > 0 &&
      parsedFormData.bookedBy !== undefined && parsedFormData.bookedBy !== "" &&
      parsedFormData.seats?.length > 0)
    setBookingSubmitted(true);
    SteLib.PostRequest("/timetables/"+state?.data?.slot?.id+"/book", parsedFormData, true, true).then((data) => {
      setActiveStep(3);
    });
  }

  const fieldOk = (field) => {
    return formik.values[field] !== undefined && formik.values[field] !== "" && formik.errors[field] === false;
  }

  const handleEndBooking = () => {
    handleClose();
    successCallback();
  }

  const paymentParagraph = () => {
    return (
      <><br/>
          <Alert severity="info">
          <AlertTitle>ATTENZIONE</AlertTitle>
            <div style={{textAlign: "left", fontSize:".8rem"}}>
              Per il pagamento della prenotazione recarsi al Cinema Aurora il sabato della settimana precedente all'evento dalle ore 14:00 alle ore 17:00. <br/>
              Se il pagamento non verrà eseguito la prenotazione verrà automaticamente cancellata. <br/>
              Per ulteriori informazioni contattare i seguenti recapiti: <br/>
              <div style={{textAlign: "center"}}><a href="mailto:aurora.pontecaffaro@gmail.com">aurora.pontecaffaro@gmail.com</a> - 338 2382886<br/></div>
              <br/>
              <div style={{textAlign: "center"}}>Ringraziamo per l'attenzione</div>
              <br/>
              </div>
        </Alert><br/>
      </>)
  }

  const validate = (values) => {
    const errors = {}
  
    if (!values.email) {
      errors.email = true;//'Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = true;//'Indirizzo Email non valido'
    }
    else
    {
      errors.email = false;
    }

    errors.name = values.name === undefined || values.name === "";
    errors.surname = values.surname === undefined || values.surname === "";
    errors.phone = values.phone === undefined || values.phone === "";
  
    return errors
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      phone: '',
      name: '',
      surname: ''
    },
    validate,
    onSubmit: (values) => {
      //alert(JSON.stringify(values, null, 2))
    },
  })

  const steps = [
    'Seleziona i Posti',
    'Le tue informazioni',
    'Conferma i dati'
  ];

  return (
    <>
      <Dialog disablePortal fullWidth maxWidth="xs" open={state?.data?.open} onClose={handleClose}>   
        <DialogTitle>
          Prenota Posti <div style={{marginTop: "-.75rem", marginBottom: "-.5rem"}}><p style={{fontSize: "1rem", lineHeight: "1rem"}}>{state?.data?.movie?.title}</p></div>
          </DialogTitle>
        <DialogContent >
          {state?.data?.loading ? 
            <div style={{margin: "2rem 0", width: "100%", textAlign: "center"}}><CircularProgress color="inherit" /></div> : 
            activeStep < 3 ? 
            <>
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <br/>
              {activeStep === -1 ? 
              <>
                <Stack spacing={3} alignItems="center">
                <h3>Errore Generico!</h3>
                <Iconify icon={'noto:cross-mark'} style={{marginTop: ".5rem", width: "7rem",height: "7rem"}}></Iconify>
                <Button onClick={handleEndBooking}>Chiudi</Button>
                </Stack>
              </> :        
              activeStep === 0 ? 
              <>
                <ScSeatBooking allowSelection={true} notAvailableSeats={notAvailableSeats} handleClick={handleSeatClick}></ScSeatBooking>
                <br/>
                {
                  selectedSeats.length > 0 ? 
                    <>
                      <span>Posti selezionati: 
                      <div style={{marginTop: ".5rem"}}>
                        {selectedSeats.map(s => {
                          return(<><Chip size='small' label={s} color="primary"></Chip>&nbsp;</>)
                        })}
                      </div>
                      </span>
                      
                    </> : <></>
                }
                {paymentParagraph()}
                <div style={{textAlign: "right"}}>
                      <Button onClick={handleClose}>Annulla</Button>
                      <Button onClick={() => setActiveStep(1)} disabled={selectedSeats.length === 0}>Successivo</Button>
                </div>
                </> : activeStep === 1 ?  <>
                <div style={{marginTop: "2rem", textAlign: "center"}}>
                  <small>Inserisci i dati della persona a cui verranno recapitate le prenotazioni</small>
                </div>
                <Stack alignItems="center" spacing={1} style={{marginTop: "1rem"}}>
                <TextField
                      margin="dense"
                      id="name"
                      label="Nome"
                      type="text"
                      style={{width: "80%"}}
                      error={formik.errors.name}
                      helperText={formik.errors.name ? "Inserire Nome" : ""}
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur} 
                      value={formik.values.name}
                      variant="standard"
                  />
                  <TextField
                      margin="dense"
                      id="surname"
                      label="Cognome"
                      type="text"
                      style={{width: "80%"}}
                      error={formik.errors.surname}
                      helperText={formik.errors.surname ? "Inserire Cognome" : ""}
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur} 
                      value={formik.values.surname}
                      variant="standard"
                  />
                  <TextField
                      margin="dense"
                      id="email"
                      label="Email"
                      type="text"
                      style={{width: "80%"}}
                      error={formik.errors.email}
                      helperText={formik.errors.email ? "Email non valida" : ""}
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur} 
                      value={formik.values.email}
                      variant="standard"
                  />
                  <TextField
                      margin="dense"
                      id="phone"
                      label="Telefono"
                      type="text"
                      style={{width: "80%"}}
                      error={formik.errors.phone}
                      helperText={formik.errors.phone ? "Numero di telefono non valido" : ""}
                      onChange={formik.handleChange} 
                      onBlur={formik.handleBlur} 
                      value={formik.values.phone}
                      variant="standard"
                  /><br/>
                  <div style={{width: "80%"}}>
                  <FormControlLabel 
                    label={<small>Accetto i termini e le condizioni dell' <a href={`${process.env.PUBLIC_URL}/privacy_policy`}>Informativa sulla privacy</a></small  >}
                    control={
                      <Checkbox 
                        error={privacy === false}
                        helperText={privacy === false ? "Accettare privacy" : ""}
                        onChange={(e) => setPrivacy(e.target.checked)} 
                        onBlur={(e) => setPrivacy(e.target.checked)} 
                        checked={privacy}
                      ></Checkbox>}
                  ></FormControlLabel></div>
                  </Stack><br/>
                  {paymentParagraph()}
                  <div style={{textAlign: "right"}}>
                      <Button onClick={handleClose}>Annulla</Button>
                      <Button onClick={handleSubmitForm} disabled={
                        !fieldOk("email") ||
                        !fieldOk("name") ||
                        !fieldOk("surname") ||
                        !fieldOk("phone") ||
                        privacy === false}>Successivo</Button>
                  </div>
                </> : <>
                    <div style={{marginTop: ".5rem", textAlign: "center"}}>
                      <small>Ricontrolla e conferma i dati inseriti</small>
                    </div>
                    <p>
                      <b>Film:</b> {state?.data?.movie?.title}<br/>
                      <b>Data:</b> {moment(state?.data?.date, "yyyy-MM-DD").format("dddd DD/MM/yyyy")}<br/>
                      <b>Orario:</b> {moment(state?.data?.slot?.time, "HH:mm:ss").format("HH:mm")}<br/>
                      <b>Nominativo:</b> {formik.values.name} {formik.values.surname}<br/>
                      <b>Email:</b> {formik.values.email}<br/>
                      <b>Telefono:</b> {formik.values.phone}
                      <div style={{margin: ".25rem 0"}}><b>Posti:&nbsp; &nbsp;</b>
                      {selectedSeats.map(s => {
                          return(<><Chip size='small' label={s} color="primary"></Chip>&nbsp;</>)
                        })}<br/></div>
                      
                    </p>
                    {paymentParagraph()}
                    <div style={{textAlign: "right"}}>
                      <Button onClick={handleClose}>Annulla</Button>
                      <LoadingButton loading={bookingSubmitted} onClick={handleSubmitBooking}>Prenota</LoadingButton>
                    </div>
                </>}
              </>
              :
              <>
                <Stack spacing={3} alignItems="center">
                <h3>Prenotazione Completata!</h3>
                <Iconify icon={'noto:party-popper'} style={{marginTop: ".5rem", width: "7rem",height: "7rem"}}></Iconify>
                <p style={{textAlign: "center"}}>A breve riceverai un'email all'indirizzo indicato, con i dettagli della tua prenotazione</p>
                <Button onClick={handleEndBooking}>Chiudi</Button>
                </Stack>
              </>  
              
              
          }
          </DialogContent>
      </Dialog>
    </>
  );
}